import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';

import {
    withStyles, Typography,
} from '@material-ui/core';

import * as UserStore from '../../../app/store/UserStore';

import { dateWithOptionalTime, isFuture } from '../../../youwell-common/dateUtils';
import { sortByDateAscending } from '../../../youwell-common/arrayUtils';
import urls from '../../../app/urls';
import { TrackedLink } from '../../../common/components';
import { activityLabels } from '../../../common/constants';

const styles = theme => ({
    root: {
        border: theme.youwell.borders.dim,
        padding: theme.spacing(1),
        background: theme.palette.grey[50],
    },
    header: {
        display: 'flex',
    },
    date: {
        marginRight: theme.spacing(1),
    },
    content: {

    },
    mapIFrame: {
        marginTop: theme.spacing(1),
        width: '100%',
        height: '400px',
    },
});

class AppointmentBox extends React.Component {
    render() {
        const {
            classes, translate, className, elements,
        } = this.props;

        const futureElements = elements?.filter(d => isFuture(d.startTime, true));

        if (!futureElements?.length) {
            return null;
        }

        const element = sortByDateAscending(futureElements, 'startTime')[0];

        return (
            <div className={classnames(classes.root, className)}>
                <TrackedLink label={activityLabels.dashboard.appointment} to={`${urls.inside.program}/${element.elementGroup}/${element.indexInGroup}`}>

                    <Typography className={classes.title} variant="caption" display="block" align="right" color="textSecondary">
                        {translate('dashboard.nextAppointment')}
                    </Typography>

                    <div className={classes.header}>
                        <Typography className={classes.date} variant="body2">
                            {dateWithOptionalTime(element.startTime, translate)}
                        </Typography>
                        <Typography className={classes.name} variant="body2">
                            {element.name}
                        </Typography>
                    </div>
                </TrackedLink>
            </div>
        );
    }
}

AppointmentBox.propTypes = {
    classes: PropTypes.object.isRequired,
    // clientConfig: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    elements: PropTypes.array,
    className: PropTypes.string,
};

AppointmentBox.defaultProps = {
    className: null,
    elements: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(UserStore.actionCreators, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AppointmentBox));
